import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";
/* ---------------- GET VALUATOR DETAIL ---------------- */
export const fetchValuatorDashboardDetail = createAsyncThunk(
	"valuator/fetchDashboardDetail",
	async (valuatorCode, { rejectWithValue }) => {
		try {
			const response = await api.get(
				`/v1/Valuator/${valuatorCode}/dashboard_v2`,
			);

			return response.data.data;
		} catch (err) {
  if (err.response?.status === 404) {
    return rejectWithValue("Data not found");
  }
  return rejectWithValue("Something went wrong");
}
	},
);
const initialState = {
	data: { cards: [], newsNAlerts: [], timeConsumedPerBooklets: [] },
	loading: false,
	error: null,
	fetched: false,
};
const valuatorDashboardDetailSlice = createSlice({
	name: "valuatorDashboardDetail",
	initialState,
	reducers: {
		clearValuator: () => initialState,
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchValuatorDashboardDetail.pending, (state) => {
				state.loading = true;
			})
			.addCase(fetchValuatorDashboardDetail.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload;
				state.fetched = true;
			})
			.addCase(fetchValuatorDashboardDetail.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload;
				state.fetched = false;
			});
	},
});

export const { clearValuator } = valuatorDashboardDetailSlice.actions;
export default valuatorDashboardDetailSlice.reducer;
